import { makeAutoObservable } from 'mobx';

class LayoutStore {
  toastConfig = null;
  platform = null;
  downloadRef = null;

  constructor() {
    makeAutoObservable(this);
  }

  setToastConfig(toastConfig) {
    this.toastConfig = toastConfig;
    return this.toastConfig;
  }

  getToastConfig() {
    return this.toastConfig;
  }

  setPlatform(platform) {
    this.platform = platform;
    return this.platform;
  }

  getPlatform() {
    return this.platform;
  }

  setDownloadRef(downloadRef) {
    this.downloadRef = downloadRef;
    return this.downloadRef;
  }

  getDownloadRef() {
    return this.downloadRef;
  }
}

export default new LayoutStore();
